import React from "react";

function ContactAddress() {
  return (
    <div className="col-xl-5 col-lg-6 col-md-8">
      <div className="contact-info-wrap">
        <div className="contact-img">
          <img src="img/images/contact_img.png" alt="" />
        </div>
        <div className="contact-info-list">
          <ul>
            <li>
              <div className="icon">
                <i className="fas fa-map-marker-alt" />
              </div>
              <div className="content">
                <p>Córdoba, Argentina.</p>
              </div>
            </li>
            <li>
              <div className="icon">
                <i className="fas fa-envelope-open" />
              </div>
              <div className="content">
                <p>support@galileopethouse.com</p>
              </div>
            </li>
          </ul>
        </div>

        <div className="contact-social">
          <ul>
            <li>
              <a
                target="_blank"
                href="https://www.facebook.com/profile.php?id=61561061009696"
                rel="noreferrer">
                <i className="fab fa-facebook-f" />
              </a>
            </li>
            <li>
              <a
                target="_blank"
                href="https://www.instagram.com/galileopethouse/"
                rel="noreferrer">
                <i className="fab fa-instagram" />
              </a>
            </li>
            <li>
              <a
                target="_blank"
                href="https://www.linkedin.com/company/galileo-pet-house"
                rel="noreferrer">
                <i className="fab fa-linkedin-in" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default ContactAddress;
